import React, { useEffect, useState } from 'react'
import FormControls from './FormControls'
import AddressFormField from './AddressFormField'
// import AddressInputs from './AddressInputs';
import tw from 'twin.macro'
import useWpFormConditionalLogic from '../../hooks/useWpFormConditionalLogic'
import useFormFieldValidation from '../../hooks/useFormFieldValidation'
import { motion, AnimatePresence } from 'framer-motion'

const Code = tw.span`rounded bg-purple-200 text-purple-700 border-purple-400 border-2 px-3 py-1 mx-2 italic`

const ProcessFormField = ({ field, value, dispatch, formState }) => {
  const formComponents = {
    text: FormControls.Input,
    textarea: FormControls.Textarea,
    address: AddressFormField,
    phone: FormControls.Phone,
    email: FormControls.Email,
    radio: FormControls.RadioField,
    checkbox: FormControls.CheckboxField,
    section: FormControls.SectionField,
    select: FormControls.SelectField,
  }

  const conditionalState = useWpFormConditionalLogic(
    field.conditionalLogic,
    formState
  )

  if (field.type in formComponents) {
    const FieldComponent = formComponents[field.type]

    const Label = () => (
      <>
        {field.type !== 'section' && field.labelPlacement !== 'hidden_label' ? (
          <FormControls.Label tw="mb-4">
            {field.label}
            {field.isRequired ? (
              <span tw="inline-block ml-1 font-normal"> (Required)</span>
            ) : null}
          </FormControls.Label>
        ) : null}
      </>
    )

    return (
      <>
        {conditionalState === null ? (
          <div tw="mb-12">
            <Label />
            <FieldComponent
              data={field}
              id={field.id}
              value={value}
              dispatch={dispatch}
              onChange={e =>
                dispatch({
                  type: 'updateField',
                  key: `input_${field.id}`,
                  value: e.target.value,
                })
              }
              required={field.isRequired}
            />
          </div>
        ) : (
          <AnimatePresence>
            {conditionalState === 'show' && (
              <motion.div
                initial={tw`opacity-0 h-0 mb-0`}
                animate={tw`opacity-100 h-auto mb-12`}
                exit={tw`opacity-0 h-0 mb-0`}
                transition={{ type: 'spring', duration: 0.2, stiffness: 50 }}
              >
                <Label />
                <FieldComponent
                  data={field}
                  id={field.id}
                  value={value}
                  dispatch={dispatch}
                  onChange={e =>
                    dispatch({
                      type: 'updateField',
                      key: `input_${field.id}`,
                      value: e.target.value,
                    })
                  }
                  required={field.isRequired}
                />
              </motion.div>
            )}
          </AnimatePresence>
        )}

        {/* {(field.conditionalLogic !== "\"\"") && (
                    <div tw="bg-yellow-100 overflow-x-hidden p-3 rounded mt-5 border-2 border-yellow-300 text-blue-800">
                        <pre>{JSON.stringify(JSON.parse(field.conditionalLogic), null, 2)}</pre>
                    </div>
                )} */}
      </>
    )
  }

  return (
    <div tw="mb-12 rounded bg-red-500 border-red-600 border-2 px-5 py-3">
      <p tw="font-bold">
        The Form Element of <Code>{field.type}</Code> does not have a component
        defined.
      </p>
      <div tw="bg-yellow-100 overflow-x-hidden p-3 rounded mt-5 border-2 border-yellow-300 text-blue-800">
        <pre>
          {JSON.stringify(
            field,
            (key, value) => {
              if (key === 'type' && value === field.type) {
                return `❌ ${value} ❌`
              }
              return value
            },
            2
          )}
        </pre>
      </div>
    </div>
  )
}

export default ProcessFormField
